import React from 'react';
// @ts-ignore
import styles from './InvoicingTableHeader.module.scss';
import useTranslation from '../../../../../Hooks/useTranslation';

const columns = [
	'component.invoicing.attachmentNumber',
	'component.invoicing.createDate',
	'component.invoicing.state',
	'component.invoicing.customer',
	'component.invoicing.invoiceCreatedBy',
	'component.invoicing.description',
	'component.invoicing.amount',
	'component.invoicing.youWillReceive',
];

const InvoicingTableHeader: React.FC = () => {
	const { t } = useTranslation();
	return (
		<thead className={styles.wrapper}>
			<tr>
				{columns.map((item, index) => (
					<th key={'headerItem_' + index}>{t(item)}</th>
				))}
			</tr>
		</thead>
	);
};

export default InvoicingTableHeader;
